import styled, { hexToRgba } from '../../theme/styled'

// TODO: split this up a bit
export const LoginContainer = styled.div`
  z-index: 1200;
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.45);
  display: flex;
  align-items: center;
  justify-content: center;

  .spacer {
    flex: 1;
  }

  .modal-inner {
    width: 680px;
    background: white;
    margin: 0;
    padding: 0 0 30px 0;
    display: flex;
    flex-direction: column;
    align-items: center;
  }

  .modal-inner .content {
    width: 100%;
    padding: 10px;
  }

  .extras {
    display: flex;
    flex-direction: row;
    align-items: center;
  }

  .split {
    display: flex;
    flex-direction: row;
    align-items: center;

    * {
      width: 50%;
      margin-right: 20px;
    }

    *:last-child {
      margin-right: 0;
    }
  }

  h4 {
    background: ${({ theme }) => theme.modal.header.background};
    padding: 10px;
    color: ${({ theme }) => theme.colors.invert};
    width: 100%;
    display: flex;
    align-items: center;
  }

  h2 {
    color: ${({ theme }) => theme.colors.default};
    font-size: 30px;
    font-weight: bold;
    max-width: 550px;
    margin: 80px auto 40px;
    text-align: center;
  }

  p,
  h3 {
    color: ${({ theme }) => theme.colors.light};
    max-width: 500px;
    font-size: 20px;

    margin: 15px auto 30px;
    text-align: center;
  }

  form,
  .bottom-container {
    margin: 5px 20px 10px;
  }

  input,
  label {
    font-weight: 400;
  }

  .checkbox-row {
    display: flex;
    flex-direction: row;
    align-items: center;
    margin: 20px 0;

    input {
      margin-right: 20px;
    }
  }

  input[type='text'],
  input[type='password'],
  input[type='email'] {
    display: block;
    width: 100%;

    border: 1px solid ${({ theme }) => theme.colors.inactive};
    height: 50px;
    line-height: 40px;
    padding: 5px 10px;
    margin: 0 0 20px;
    font-size: ${({ theme }) => theme.fonts.largeSize};
  }

  input[type='submit'] {
    background: ${({ theme }) => theme.colors.brand};
    color: ${({ theme }) => theme.colors.invert};
    border: 0;
    width: 100%;
    font-size: ${({ theme }) => theme.fonts.largeSize};
    text-transform: uppercase;
    margin: 10px 0 20px;
    padding: 5px 0;
    height: 50px;
    cursor: pointer;

    &:disabled {
      opacity: 0.6;
    }

    &:hover {
      background: ${({ theme }) => theme.hoverColors.brand};
    }
  }

  select {
    appearance: none;

    color: ${({ theme }) => theme.colors.default};
    background: ${({ theme }) => theme.colors.invert};
    border: 1px solid ${({ theme }) => theme.colors.inactive};

    line-height: 40px;
    height: 50px;

    margin-left: auto;
    padding: 5px 10px;

    font-size: ${({ theme }) => theme.fonts.largeSize};
  }

  .spinner {
    position: absolute;
    top: 50%;
    left: 50%;
    width: 60px;
    height: 60px;
    margin: -30px 0 0 -30px;
    animation: rotation 1s infinite linear;
    border-left: 6px solid
      ${({ theme }) => hexToRgba(theme.colors.modalHead, '0.15')};
    border-right: 6px solid
      ${({ theme }) => hexToRgba(theme.colors.modalHead, '0.15')};
    border-bottom: 6px solid
      ${({ theme }) => hexToRgba(theme.colors.modalHead, '0.15')};
    border-top: 6px solid
      ${({ theme }) => hexToRgba(theme.colors.modalHead, '0.9')};
    border-radius: 100%;
  }

  @keyframes rotation {
    from {
      transform: rotate(0deg);
    }
    to {
      transform: rotate(359deg);
    }
  }
`



// WEBPACK FOOTER //
// ./src/Components/LoginForm/Common.ts